<template>
    <v-responsive v-if="board">
        <v-card tile elevation="0">
            <v-card-title class="tit tit--xs">
                <v-row>
                    <v-col cols="auto">
                        제목: {{ board.subject }}
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">작성일자: {{ $dayjs(board.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</v-col>
                </v-row>
            </v-card-title>
            <v-divider/>
            <v-card-text class="font-size-14">
                <v-responsive min-height="400">
                    <p v-html="board.content"></p>
                </v-responsive>
            </v-card-text>
        </v-card>
    </v-responsive>
</template>

<script>
export default {
    props: {
        board: { type: Object }
    },
	components: {
	},
}
</script>
